<template>
  <div class="bottom_tree_table">
    <div class="bottom_left">
      <major-tree :type="1" @detailBtn="detailBtn"></major-tree>
    </div>
    <div class="bottom_right">
      <div class="right_button" style="display: inline-block">
        <el-button v-if="refreshRevit" type="primary" size="small" plain @click="mjfreshData">
          刷新
        </el-button>
        <el-button v-if="uploadRevit" type="primary" size="small" plain @click="addStandard">
          上传
        </el-button>
        <el-button v-if="downRevit" :disabled="!fileID" type="primary" size="small" plain @click="downloadFile">
          下载
        </el-button>
        <el-button v-if="deleRevit" :disabled="!fileID" type="primary" size="small" plain @click="deleteListData">
          删除
        </el-button>
        <el-button v-if="editRevit" :disabled="!fileID" type="primary" size="small" plain @click="updateStandard">
          修改
        </el-button>
      </div>
      <div class="right_table">
        <el-table :data="personTable" border highlight-current-row style="width: 100%; height: 100%" height="100%"
          @row-click="handleCurrent">
          <template slot="empty">
            <img :src="zanwu" alt="" />
            <p style="font-size: 16px; color: #000; margin-top: 36px">
              暂无数据
            </p>
          </template>
          <el-table-column label="文件名称" prop="fileName" min-width="200px" />
          <el-table-column label="文件大小(b)" prop="fileSize" />
          <el-table-column label="Revit版本" prop="revitVersion" />
          <el-table-column label="所属公司" prop="depName" />
          <el-table-column label="修改时间" prop="updateDate" />
          <el-table-column label="上传人" prop="userName" />
          <el-table-column label="备注" prop="remark" />
        </el-table>
      </div>
    </div>
    <el-dialog v-dialogDrag :title="revitTitle" :visible.sync="revitDialog" :close-on-click-modal="false"
      :modal-append-to-body="false" :close-on-press-escape="false" :before-close="getReset" width="600px">
      <el-form ref="revitForm" :model="revitForm" :rules="rules" class="demo-form-inline" label-width="100px" size="small">
        <el-form-item v-if="submitType == 1" label="文件名称" prop="fileName">
          <el-input v-model="revitForm.fileName" maxlength="100" show-word-limit size="small">
            <template slot="append">
              .rvt
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="Revit版本" prop="revit">
          <el-select v-model="revitForm.revit" value-key="revitID" style="width:100%" clearable filterable size="small">
            <el-option v-for="(item, revitID) in revitList" :key="revitID" :value="item"
              :label="item.revitNameOrVersion">
              {{ item.revitNameOrVersion }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属公司" prop="depName">
          <el-input v-model="revitForm.depName" readonly size="small" @focus="selectDepName" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="revitForm.remark" :autosize="{ minRows: 2, maxRows: 6 }" type="textarea" maxlength="200" size="small" />
        </el-form-item>
        <el-form-item v-if="submitType == 0" label="文件上传" prop="fileList">
          <el-upload :limit="1" :on-remove="dataOnRemove" :on-change="changeFile" :file-list="revitForm.fileList"
            :auto-upload="false" accept=".rvt" style="display: inline-block; margin: 0 10px" action="/">
            <el-button size="small" type="primary">
              上传文件
            </el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="load == true" size="small" @click="getReset">取 消</el-button>
        <el-button v-if="submitType == 0" :loading="load" type="primary" size="small" @click="addRevitdBtn"> 确 定 </el-button>
        <el-button v-if="submitType == 1" type="primary" size="small" @click="updateRevitdBtn">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag :visible.sync="companyDialog" :close-on-click-modal="false" :modal-append-to-body="false"
      title="组织架构" width="600px">
      <el-input v-model="filterText" placeholder="输入关键字进行过滤" clearable size="small" />
      <div class="centerTree">
        <org-tree ref="orgTree" :filter-text="filterText" @orgcurrent="currentOrgChangeHandler"></org-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="companyDialog = false">取 消</el-button>
        <el-button type="primary" size="small" @click="sureSelectBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import revitService from "@/CommonDP/service/revitTemplate-service";
import orgTree from "@/CommonDP/components/structure/orgTree.vue";
import majorTree from "@/CommonDP/components/structure/majorTree.vue";
import { checkPermission, disablePrompt } from "@/CommonDP/utils/routeAuth";
import { mapState } from "vuex";
export default {
  name: "RevitMaintenance",
  components: { orgTree, majorTree },
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      majorID: undefined,
      majorName: "",
      personTable: [],
      currentRow: {},
      submitType: "",
      fileID: undefined,
      revitList: [],
      // 上传使用
      companyDialog: false,
      revitDialog: false,
      filterText: "",
      selectTree: {}, // 所选公司数据
      revitForm: { fileName: "", depName: "", remark: "", revit: "", fileList: [] },
      rules: {
        revit: [{ required: true, message: "请选择Revit版本", trigger: "change" }],
        depName: [{ required: true, message: "请选择所属公司", trigger: "change" }],
        fileName: [{ required: true, message: "文件名称必填", trigger: "blur" }],
        fileList: [{ required: true, message: "请上传文件", trigger: "change" }]
      },
      load: false,
      refreshRevit: checkPermission(this.$allPerms.REVITMAINTENANCE_REFRESH),
      deleRevit: checkPermission(this.$allPerms.REVITMAINTENANCE_DALE),
      uploadRevit: checkPermission(this.$allPerms.REVITMAINTENANCE_UPLOAD),
      downRevit: checkPermission(this.$allPerms.REVITMAINTENANCE_DOWN),
      editRevit: checkPermission(this.$allPerms.REVITMAINTENANCE_EDIT)
    };
  },
  computed: {
    revitTitle() {
      return ["添加模板", "修改模板"][this.submitType];
    },
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    })
  },
  created() {
    this.getRevitDownList();
  },
  methods: {
    dataOnRemove(file, fileList) {
      this.revitForm.fileList = [];
      this.$refs.revitForm.validateField("fileList");
    },
    // 上传图片
    changeFile(file, fileList) {
      this.revitForm.fileList = fileList.map(item => {
        if (item.raw) {
          return item.raw;
        } else {
          return item;
        }
      });
      this.$refs.revitForm.validateField("fileList");
    },
    // 获取revit下拉框数据
    async getRevitDownList() {
      const { data } = await revitService.getRevitVersionDropDownBox();
      this.revitList = data;
    },
    detailBtn(val) {
      this.majorID = val.specId;
      this.majorName = val.specName;
      this.getrevitList(val.specId);
    },
    // 刷新
    mjfreshData() {
      this.currentRow = {};
      this.fileID = undefined;
      this.getrevitList(this.majorID);
    },
    // 获取图层
    async getrevitList(item) {
      this.fileID = undefined;
      const params = {
        id: item,
        enterpriseId: this.enterpriseId
      };
      const res = await revitService.getrevitSystemModelMaintenanceList(params);
      this.personTable = res.data || [];
    },
    // 选中的节点
    handleCurrent(val) {
      this.currentRow = val;
      this.fileID = val.fileID;
      this.revitForm.revit = {
        revitID: val.revitVersionID,
        revitNameOrVersion: val.revitVersion
      };
      this.revitForm.fileName = val.fileName.split(".")[0];
      this.revitForm.remark = val.remark;
      this.revitForm.depName = val.depName;
    },
    // 上传
    addStandard() {
      const a = disablePrompt();
      if (a) {
        this.revitDialog = true;
        this.submitType = 0;
        this.revitForm = { fileName: "", depName: "", remark: "", revit: "", fileList: [] };
      }
    },
    // 修改
    updateStandard() {
      const a = disablePrompt();
      if (a) {
        this.revitDialog = true;
        this.submitType = 1;
      }
    },
    // 下载
    async downloadFile() {
      const a = disablePrompt();
      if (a) {
        revitService.downloadDepartmentNameFile(this.fileID).then(response => {
          if (response.type === "application/json") {
            const fileReader = new FileReader();
            fileReader.onloadend = () => {
              const jsonData = JSON.parse(fileReader.result);
              // 后台信息
              this.$message({ message: jsonData.message, type: "error" });
            };
            fileReader.readAsText(response); // 或者读取response.data
          } else {
            const link = document.createElement("a");
            const blob = new Blob([response], {
              type: "application/octet-stream"
            });
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", decodeURI(this.currentRow.fileName));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        });
      }
    },
    // 删除
    async deleteListData() {
      const a = disablePrompt();
      if (a) {
        await this.$confirm("此操作将删除本行数据，是否继续？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        await revitService.deleteRevitFile({ id: this.fileID });
        this.$message({
          showClose: true,
          type: "success",
          message: "删除成功"
        });
        this.mjfreshData(); // 刷新列表
      }
    },
    // 选择所属公司
    selectDepName() {
      this.companyDialog = true;
    },
    // 选中节点
    currentOrgChangeHandler(val) {
      this.selectTree = val;
    },
    // 上传确定
    addRevitdBtn() {
      this.$refs.revitForm.validate(valid => {
        if (valid) {
          const params = {
            specId: this.majorID,
            specName: this.majorName,
            revitVersionId: this.revitForm.revit.revitID,
            revitVersion: this.revitForm.revit.revitNameOrVersion,
            depId: this.selectTree.deptId,
            depName: this.selectTree.deptName,
            remark: this.revitForm.remark,
            enterpriseId: this.enterpriseId
          };
          const form = new FormData();
          for (const key in params) {
            if (Object.hasOwnProperty.call(params, key)) {
              const element = params[key];
              form.append(key, element);
            }
          }
          for (const item of this.revitForm.fileList) {
            form.append("filervt", item);
          }
          this.load = true;
          revitService.uploadDepartmentNameFile(form).then(data => {
            if (data.result === "0") {
              this.$message({
                message: "添加成功",
                type: "success"
              });
              this.load = false;
              this.getrevitList(this.majorID);
              this.getReset();
            } else {
              this.load = false;
            }
          }).catch((error) => {
            console.log(error);
            this.load = false;
          });
        } else {
          return false;
        }
      });
    },
    // 修改确定
    updateRevitdBtn() {
      this.$refs.revitForm.validate(valid => {
        if (valid) {
          const params = {
            fileId: this.fileID,
            fileName: this.revitForm.fileName.concat(".rvt"),
            revitVersionId: this.revitForm.revit.revitID,
            revitVersion: this.revitForm.revit.revitNameOrVersion,
            depId: this.selectTree ? this.selectTree.deptId : this.this.currentRow.deptId,
            depName: this.selectTree ? this.selectTree.deptName : this.this.currentRow.deptName,
            remark: this.revitForm.remark
          };
          revitService.updateRevitFile(params).then(data => {
            this.$message({
              message: "修改成功",
              type: "success"
            });
            this.getrevitList(this.majorID);
            this.getReset();
          });
        } else {
          return false;
        }
      });
    },
    // 组织架构确定
    sureSelectBtn() {
      this.companyDialog = false;
      this.filterText = "";
      this.$set(this.revitForm, "depName", this.selectTree.deptName);
    },
    // 清空表单
    getReset() {
      this.revitForm = { fileName: "", depName: "", remark: "", revit: "", fileList: [] };
      this.revitDialog = false;
      this.$refs.revitForm.resetFields();
    }
  }
};
</script>
<style lang="scss" scoped>
$top-button-height: 42px;
$middle-height: 30px;
$left-width: 256px;
.bottom_tree_table {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  .bottom_left {
    position: absolute;
    top: 10px;
    bottom: 10px;
    left: 0;
    width: $left-width;
    border-right: 1px solid #ebefff;
    .left_tree {
      overflow: auto;
      position: absolute;
      left: 0;
      top: 10px;
      bottom: 10px;
      right: 0;
      li {
        display: flex;
        border-bottom: 0;
        align-items: center;
        padding: 2px 30px;
        cursor: pointer;
        font-size: 14px;
        line-height: 26px;
        color: var(--key-color);
        img {
          margin-right: 8px;
        }
      }
      .active {
        background: rgba(85, 132, 255, 0.1);
      }
    }
  }
  .bottom_right {
    position: relative;
    height: 100%;
    margin-left: $left-width + 10px;
    display: flex;
    flex-direction: column;
    .right_button {
      padding: var(--middle-space) var(--big-space);
    }
    .right_table {
      height: 1px;
      flex-grow: 1;
      padding: 0 var(--big-space) var(--middle-space);
    }
  }
  .centerTree {
    overflow: auto;
    margin-top: 10px;
    height: 500px;
    padding-left: 12px;
    border-right: 1px solid rgb(209, 206, 206);
    .tree_1 {
      font-size: 14px;
    }
  }
}
/deep/.el-tree-node__content {
  height: 31px;
  line-height: 31px;
}
/deep/.el-divider--horizontal {
  margin: 10px 0;
}
</style>
